import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog2',
  template: `
  <ng-template #dialogContainer>
 
    <div mat-dialog-title class="w-100 d-flex justify-content-between">
      <div class="w-auto mx-auto logo-img-header-container" [ngClass]="{'d-flex' : headerImgSrc.length>0}">
        <img *ngIf="headerImgSrc" src="{{headerImgSrc}}" alt="" class="logo-img-header" [ngClass]="{'my-auto me-1' : headerImgSrc.length>0}">
        <h1 [ngClass]="{'my-auto' : headerImgSrc.length>0}" class="text-center mx-auto">{{title}}</h1>
      </div>
      <button mat-icon-button mat-dialog-close class="btn-dialog-close"><mat-icon>close</mat-icon></button>
    </div>
    <div mat-dialog-content >
        <ng-content></ng-content>
    </div>
    <div mat-dialog-content>
      <ng-content select="[dialog-body]" class="mvh-100"></ng-content>
    </div>

    <div mat-dialog-actions *ngIf="showMatActionButtons">
      <ng-content select="[dialog-actions]"></ng-content>
    </div>
    </ng-template>
  `,
  styles: [` 
`],
})
export class DialogComponent2 implements OnInit {

  @ViewChild('dialogContainer') public dialogContainer: any;
  private dialogRef: any;

  @Input() title!: string;
  @Input() showMatActionButtons: boolean = false;
  @Input() headerImgSrc: string = '';

  //Config
  @Input() disableClose!: boolean;
  @Input() hasBackdrop!: boolean;
  private _width: any;
  @Input() set width(width: any) {
    this._width = width;
  }

  private _height: any;
  @Input() set height(height: any) {
    this._height = height;
  }

  @Input() panelClasses: string[] = [];
  @Input() autoFocus: boolean = false;

  //Show and Hide action
  private _show: boolean = false;
  @Input() set show(show: boolean) {
    this._show = show;
    show ? this.openDialog() : this.closeDialog();
    this.showChange.emit(this._show);
  }
  get show(): boolean {
    return this._show;
  }

  @Input() buttonActionsJustifyType: string = 'justify-content-end';

  //Events
  @Output() onDialogPreventClosed = new EventEmitter();
  @Output() onDialogClosed = new EventEmitter();

  @Output()
  showChange = new EventEmitter<boolean>();

  private _preventCloseIfPendingChanges: boolean = false;
  @Input() set preventCloseIfPendingChanges(
    preventCloseIfPendingChanges: boolean
  ) {
    this._preventCloseIfPendingChanges = preventCloseIfPendingChanges;
  }
  get preventCloseIfPendingChanges(): boolean {
    return this._preventCloseIfPendingChanges;
  }

  @Input() set maximize(
    maximize: boolean
  ) {
    this.maximizeToggle(maximize);
  }

  constructor(public _dialog: MatDialog) { }

  ngOnInit(): void {
  }

  private openDialog(): void {
    setTimeout(() => {
      this.dialogRef = this._dialog.open(this.dialogContainer, {
        height: this.height,
        width: this.width,
        maxHeight: '100vh',
        maxWidth: '100vw',
        panelClass: this.panelClasses,
        autoFocus: false,
        disableClose: this.disableClose,
        hasBackdrop: this.hasBackdrop
      });

      this.dialogRef.afterClosed().subscribe(() => {
        //Set to false
        this.show = false;
      });
    });
  }

  public closeDialog(): void {
    if (this.dialogRef && !this.preventCloseIfPendingChanges) {
      this.dialogRef.close();
      this.onDialogClosed.emit('');
    } else {
      this.onDialogPreventClosed.emit('');
    }
  }

  private maximizeToggle(maximize: boolean): void {
    if (maximize) {
      this.dialogRef.updateSize('100vw', '100vh');
    } else {
      this.dialogRef.updateSize(this.width, this.height);
    }
  }
}

